import { defineMessages } from "react-intl";

export const messages = defineMessages({
  unsavedPreset: {
    defaultMessage: "Unsaved preset",
    id: "A+g/VP",
  },
  filterPreset: {
    defaultMessage: "Filter preset",
    id: "3PVGWj",
  },
  savePreset: {
    defaultMessage: "Save search as preset",
    id: "scTuDZ",
  },
  noPresets: {
    defaultMessage: "Saved search queries will appear here",
    id: "eW36Jx",
  },
});
